import type { GlobalRisk } from "@eu.mdotm.api/sphere";
import { type WorldGridMapSnapshot, WorldGrid } from "$root/components/RegimeAnalysisTool/WorldGrid";
import { hmmRepository } from "$root/functional-areas/hmm/repository";
import { RegionContext } from "$root/widgets-architecture/contexts/region";
import { useWidgetOptions } from "$root/widgets-architecture/layout/WidgetsMapper/context";
import { type ContextContent, withContext } from "@mdotm/shadcn/legacy/react-extensions";

export function generateSnapshotLevel(data: Array<GlobalRisk>): Array<WorldGridMapSnapshot> {
	return data.map(({ dateTime, risks }) => ({
		time: dateTime!,
		snapshot: (risks ?? []).map(({ assetClassess, geo }) => ({
			firstLevel: {
				name: geo!,
				riskLevel: 0,
				weight: 1,
				regimeProbability: 1,
				secondLevels: (assetClassess ?? []).map((ac) => ({
					name: ac.macroName!,
					riskLevel: ac.valueOnMap!,
					weight: ac.value!,
					regimeProbability: ac.regimeProbability!,
					thirdLevels: (ac.sectors ?? []).map((sector) => ({
						name: sector.assetClassIdentifier!,
						riskLevel: sector.valueOnMap!,
						weight: sector.value!,
						regimeProbability: sector.regimeProbability!,
						fourthLevels: (sector.subSectors ?? []).map((sub) => ({
							name: sub.assetClassIdentifier!,
							riskLevel: sub.valueOnMap!,
							weight: sub.value!,
							regimeProbability: sub.regimeProbability!,
						})),
					})),
				})),
			},
		})) satisfies WorldGridMapSnapshot["snapshot"],
	}));
}

const WorldGridMapBlock = (_props: ContextContent<typeof RegionContext>) => {
	useWidgetOptions(
		() => ({
			title: "Global risk map",
			maxHeight: "none",
		}),
		[],
	);

	return (
		<div className="max-w-[1920px] mx-auto w-full">
			<WorldGrid
				dateProvider={(valueOnMap) => hmmRepository.globalRiskMapDatesIsoFormat.fetchQuery(valueOnMap)}
				dataProvider={async (valueOnMap, { from, to }) => {
					return generateSnapshotLevel(await hmmRepository.globalRiskMapIsoFormat.fetchQuery(valueOnMap, { from, to }));
				}}
			/>
		</div>
	);
};

export default withContext(RegionContext)(WorldGridMapBlock);
